import type { UniversityRepository } from "@src/domain/universities/repository/university_repository";
import type { UniversityDTO } from "../dto/university.dto";

/**
 * Use Case: List Universities
 */
export class ListUniversitiesUseCase {
    constructor(private readonly universityRepository: UniversityRepository) { }

    async execute(skip?: number, limit?: number): Promise<{ universities: UniversityDTO[]; total: number }> {
        const result = await this.universityRepository.findAll(skip, limit);

        const universities: UniversityDTO[] = result.universities.map(u => ({
            university_id: u.universityId,
            name: u.name,
            code: u.code,
            description: u.description,
            address: u.address,
            website: u.website,
            is_active: u.isActive,
            created_at: u.createdAt.toISOString(),
            updated_at: u.updatedAt.toISOString(),
        }));

        return {
            universities,
            total: result.total,
        };
    }
}